import { Button, DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutManualSettlementList extends Layout {
    buttonPrintPost: Button;
    layoutheaderTitle: LayoutHeader;
    sourceManualSettlementList: DataSource;
    tableManualSettlementList: Table;
}
